import { CODE_KEY_MAP } from '../../keyboardShortcuts/codeKeyMap.js';
import { modifierKeys } from '../../keyboardShortcuts/modifierKeys.js';

const recordedHotkeysToAccelerator = (recordedHotkeys) => {
  return recordedHotkeys.map((hotkey) => {
    if (modifierKeys.includes(hotkey.value.toLowerCase())) {
      return hotkey.value;
    }
    const sanitized = hotkey.code.replace(/Key|Digit/g, "");
    return CODE_KEY_MAP[sanitized.toLowerCase()] || sanitized;
  }).join("+");
};

export { recordedHotkeysToAccelerator };
//# sourceMappingURL=recordedHotkeysToAccelerator.js.map
